import { appNamespace, SELLER_PORTAL_ACCESS_TOKEN } from '@/_constants';
import { LocalStorageWorker } from '../localstorage-worker';

export const clearUserInfoCache = () => {
  LocalStorageWorker.deleteItem(`${appNamespace}.id`);
  LocalStorageWorker.deleteItem(SELLER_PORTAL_ACCESS_TOKEN);
};
